import React, {Component} from 'react';
import {Spin} from 'antd';
import {api, app} from "../app";
import utils from "../utils";
import xbImg from "../assets/xb.png";

class ChestCanvas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: {},
            loading: true,
            canvasId: "card-canvas-" + props.id,
        };
    }

    /**
     * 数据
     * @param mall_id
     */
    dataSource = async () => {
        try {
            let {other} = this.props, params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                indexno_card: this.props.indexno,
            };
            if (other) params = Object.assign(params, other);
            let {flag, data, msg} = await app.post(api.CardDetails, params);
            if (flag === 1) {
                await this.drawCanvas(data);
            } else {
                app.alert(msg, 'warn');
                this.setData({loading: false});
            }
        } catch (e) {
            console.error(e);
            this.setData({loading: false});
        }
    }

    /**
     * 开始画板
     * @param id
     */
    drawCanvas = async (dataInfo) => {
        const {canvasId} = this.state;
        const canvas = document.getElementById(canvasId);
        const ctx = canvas.getContext("2d");
        let img = await utils.imageLoad(ctx, xbImg);
        ctx.font = "bold 12px 微软雅黑";
        let ix = (400 - img.width) / 2,
            iy = (400 - img.height * 2) / 3,
            iy2 = iy * 2 + img.height;
        ctx.drawImage(img, ix, iy);
        ctx.drawImage(img, ix, iy2);
        ctx.fillStyle = "#FFFF00";
        ctx.textAlign = "center";
        //姓名
        ctx.font = "bold 40px 黑体";
        let vname = dataInfo.vname.split('').join(' ');
        ctx.fillText(vname, 400 / 2, iy + 56);

        //拼音
        ctx.fillText(dataInfo.pinyin, 400 / 2, iy + 100);

        //存心编号
        ctx.font = "bold 80px 黑体";
        ctx.fillText(dataInfo.bsrno, 400 / 2, iy2 + 90);
        this.setData({loading: false});
    }

    /**
     * 设置值
     * @param obj
     */
    setData = (obj, cb) => {
        if (this._isMounted) {
            this.setState(obj, () => {
                if (cb) cb();
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setData({
            loading: true,
            indexno: nextProps.indexno,
        }, async () => {
            await this.dataSource();
        });
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.dataSource();

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {loading, canvasId} = this.state;
        return (
            <div className="card-canvas" style={{width: 400, height: 400, textAlign: "center"}}>
                <canvas id={canvasId} width="400" height="400" hidden={loading}/>
                <Spin size="large" hidden={!loading}/>
            </div>
        );
    }
}

export default ChestCanvas;



// WEBPACK FOOTER //
// ./src/components/ChestCanvas.jsx